import React, { useState, useEffect } from "react";
import "./CookieConsent.css";

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consented = localStorage.getItem("cookie-consent");
    if (!consented) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookie-consent", "all");
    setVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem("cookie-consent", "essential");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__card">
        <div className="cookie-consent__content">
          <p className="cookie-consent__text">
            We use cookies to enhance your experience. By continuing, you agree to our use of cookies.
          </p>
          <div className="cookie-consent__actions">
            <button className="cookie-consent__btn cookie-consent__btn--primary" onClick={acceptAll}>
              Accept All
            </button>
            <button className="cookie-consent__btn cookie-consent__btn--secondary" onClick={acceptEssential}>
              Essential Only
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
